(() => {
  if (window.MQAAARProductCardBooted) return;
  window.MQAAARProductCardBooted = true;

  const moveGallery = (gallery, delta) => {
    const count = Number(gallery.dataset.count) || 1;
    let index = Number(gallery.dataset.index) || 0;
    index = (index + delta + count) % count;
    gallery.dataset.index = String(index);
    const track = gallery.querySelector('[data-mqaar-gallery-track]');
    if (track) track.style.transform = `translateX(${document.documentElement.dir === 'rtl' ? index * 100 : -index * 100}%)`;
    const progress = gallery.querySelector('[data-gallery-progress]');
    if (progress) progress.textContent = `${index + 1} / ${count}`;
    gallery.querySelectorAll('.mqaar-card__slide').forEach((slide, slideIndex) => {
      slide.tabIndex = slideIndex === index ? 0 : -1;
    });
  };

  const setGallery = (gallery, index) => {
    const current = Number(gallery.dataset.index) || 0;
    if (current !== index) moveGallery(gallery, index - current);
  };

  document.addEventListener('click', event => {
    const mobileSizes = event.target.closest('[data-mobile-sizes-toggle]');
    if (mobileSizes) {
      event.preventDefault();
      event.stopPropagation();
      const card = mobileSizes.closest('[data-mqaar-card]');
      const willOpen = !card.classList.contains('is-mobile-quick-open');
      document.querySelectorAll('.mqaar-card.is-mobile-quick-open').forEach(openCard => {
        if (openCard !== card) {
          openCard.classList.remove('is-mobile-quick-open');
          openCard.querySelector('[data-mobile-sizes-toggle]')?.setAttribute('aria-expanded', 'false');
        }
      });
      card.classList.toggle('is-mobile-quick-open', willOpen);
      mobileSizes.setAttribute('aria-expanded', String(willOpen));
      return;
    }

    const size = event.target.closest('[data-size-variant]');
    if (size && !size.disabled) {
      event.preventDefault();
      event.stopPropagation();
      const form = size.closest('form');
      const input = form?.querySelector('[data-size-variant-input]');
      const submit = form?.querySelector('[data-size-submit]');
      if (input) input.value = size.dataset.sizeVariant;
      form?.querySelectorAll('[data-size-variant]').forEach(button => button.setAttribute('aria-pressed', String(button === size)));
      const status = form?.querySelector('[data-size-status]');
      if (status) status.textContent = `Adding size ${size.textContent.trim()}...`;
      const card = size.closest('[data-mqaar-card]');
      submit?.click();
      window.setTimeout(() => {
        card?.classList.remove('is-mobile-quick-open');
        card?.querySelector('[data-mobile-sizes-toggle]')?.setAttribute('aria-expanded', 'false');
      }, 350);
      return;
    }

    const arrow = event.target.closest('[data-gallery-prev],[data-gallery-next]');
    if (arrow) {
      event.preventDefault();
      event.stopPropagation();
      moveGallery(arrow.closest('[data-mqaar-gallery]'), arrow.hasAttribute('data-gallery-next') ? 1 : -1);
    }
  });

  document.addEventListener('pointerover', event => {
    if (!matchMedia('(hover:hover) and (pointer:fine)').matches) return;
    const media = event.target.closest('.mqaar-card__media');
    if (!media || media.contains(event.relatedTarget)) return;
    const gallery = media.querySelector('[data-hover-gallery]');
    if (gallery && Number(gallery.dataset.count) > 1) {
      gallery.dataset.hoverOrigin = gallery.dataset.index;
      setGallery(gallery, 1);
    }
  });

  document.addEventListener('pointerout', event => {
    if (!matchMedia('(hover:hover) and (pointer:fine)').matches) return;
    const media = event.target.closest('.mqaar-card__media');
    if (!media || media.contains(event.relatedTarget)) return;
    const gallery = media.querySelector('[data-hover-gallery]');
    if (gallery) {
      setGallery(gallery, Number(gallery.dataset.hoverOrigin) || 0);
      delete gallery.dataset.hoverOrigin;
    }
  });
})();
